import { Loader } from '@grafikr/components';

import isEditable from 'utils/is-editable';
import { allowKeyAction } from 'utils/keypress';

export default Loader(({ node }, load) => {
  const key = node.dataset.loadKey;

  const eventHandler = (event: KeyboardEvent) => {
    if (isEditable(document.activeElement)) {
      return;
    }

    if (allowKeyAction(event, key)) {
      load();
    }
  };

  document.addEventListener('keydown', eventHandler);
});
